import Vue from 'vue';
import Router from 'vue-router';
import StravaAuth from './domain/StravaAuth';
import logger from './domain/ClientLogger';
import store from './store';
import homeRoutes from './routes/home';
import devPlaygroundRoutes from './routes/devPlayground';
import activityRoutes from './routes/activity';
import segmentRoutes from './routes/segments';

const stravaAuth = new StravaAuth();
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...homeRoutes,
    ...devPlaygroundRoutes,
    ...activityRoutes,
    ...segmentRoutes,
  ],
});

router.beforeEach((to, from, next) => {
  logger.log(`vue-router: to => ${to.path}`);
  // if path == '/_=_' - check base url in chrome -http://localhost:xxxx/# <= notice the hash
  //                   - must set router mode: 'history',
  //                   - must set router base: process.env.BASE_URL,
  if (stravaAuth.isTokenExchangePath(to.path)) {
    let code: string = '';
    if (typeof to.query.code === 'string') {
       code = to.query.code;
    } else {
       code = to.query.code[0];
    }
    stravaAuth.tokenExchange(code, (a , auth) => {
        store.commit('signedIn', { athlete: a, code, token: auth.accessToken, auth });
        router.push({name: 'start'});
    });
  }
  next();
});

router.beforeEach((to, from, next) => {
  const title = process.env.VUE_APP_NAME;
  if (to.meta.title) {
    document.title = `${to.meta.title} | ${title}`;
  } else {
    document.title = title;
  }
  next();
});

export default router;
